import isEmpty from 'lodash.isempty';
import moment from 'moment';
import * as yup from 'yup';

const getPlainList = data =>
  data
    ? data.content_progress.question_progresses
        .filter(d => d.answer === 't')
        .map(d => d.question.title)
    : [];

export const prepareDataList = data => {
  if (isEmpty(data)) return null;

  if (!Array.isArray(data)) return { plain: getPlainList(data) };

  const plainData = data.find(
    ({ content_progress }) => content_progress.question_set
  );

  const personal = data.find(
    ({ content_progress }) => content_progress.answers_list
  );

  return {
    personal,
    plain: getPlainList(plainData),
  };
};

export const prepareTriggersData = triggers => {
  if (isEmpty(triggers)) return null;

  const getTriggersByType = type => {
    if (Array.isArray(triggers))
      return (
        prepareDataList(
          triggers.filter(({ extra_info }) => extra_info === type)
        ) || {}
      );

    return triggers.extra_info === type ? prepareDataList(triggers) : {};
  };

  return {
    external: getTriggersByType('external'),
    internal: getTriggersByType('internal'),
  };
};

const sortDates = (a, b) =>
  new Date(a.date) > new Date(b.date)
    ? 1
    : new Date(b.date) > new Date(a.date)
    ? -1
    : 0;

export const prepareChartData = (satisfaction, risk) => {
  const data = {};
  if (!satisfaction || !risk) {
    return data;
  }
  Object.keys(satisfaction).forEach(date => {
    const formatDate = moment.utc(date, 'YYYY-MM-DD');
    data[formatDate] = { sts: satisfaction[date] };
  });

  Object.keys(risk).forEach(date => {
    const formatDate = moment.utc(date, 'YYYY-MM-DD');
    data[formatDate]
      ? (data[formatDate].rsk = risk[date])
      : (data[formatDate] = { rsk: risk[date] });
  });

  return Object.keys(data)
    .map(date => ({
      date,
      ...data[date],
    }))
    .sort(sortDates)
    .map(item => {
      const date = moment(new Date(item.date)).format('D MMM');
      return {
        ...item,
        date,
      };
    });
};

export const prepareMonthlyTable = ({ questions, answers }) => {
  const data = [];
  const question_answers = answers.map((answer, index) => ({
    id: index,
    title: answer,
  }));
  questions.forEach(({ id, question, description }) =>
    data.push({ id, title: question, question_answers, description })
  );
  return {
    content: {
      questions: data,
    },
  };
};

export const getValuesFromGoals = goals => {
  const values = {};

  if (isEmpty(goals)) {
    return values;
  }

  const { connected_question_progresses } = goals.content_progress;
  connected_question_progresses.forEach(
    ({ connected_question, question_progresses, start_time }) => {
      const { id } = connected_question;
      values[id] = {};
      const value = question_progresses[0];
      const deadlineValue = question_progresses[1];
      const awardValue = question_progresses[2];

      values[id].id = value.question.id;
      values[id].value = value.answer || null;

      if (deadlineValue) {
        values[id].deadlineId = deadlineValue.question.id;
        values[id].deadline =
          value.answer && deadlineValue.answer ? deadlineValue.answer : null;
        values[id].start = start_time || deadlineValue.created_at;
      }

      if (awardValue) {
        values[id].awardId = awardValue.question.id;
        values[id].award = awardValue.answer || null;
      }
    }
  );
  return values;
};

export const prepareGoalsToSubmit = values =>
  Object.keys(values).map(id => ({
    id,
    start_time: values[id].start,
    questions: [
      {
        id: values[id].id,
        answer: values[id].value,
      },
      {
        id: values[id].deadlineId || null,
        answer: values[id].deadline || null,
      },
      {
        id: values[id].awardId || null,
        answer: values[id].award || null,
      },
    ],
  }));

export const getGoalsValidation = (goals = {}) => {
  const schema = {};
  const {
    content_progress: { connected_question_progresses },
  } = goals;

  connected_question_progresses.forEach(({ connected_question }) => {
    schema[connected_question.id] = yup.object().shape({
      deadline: yup
        .number()
        .nullable()
        .min(1, 'Must be greater than or equal to 1')
        .max(365, 'Must  be less than or equal to 365'),
      value: yup
        .string()
        .nullable()
        .trim()
        .min(1, 'The field is required'),
      award: yup
        .string()
        .nullable()
        .trim(),
    });
  });

  return yup.object().shape(schema);
};



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/utils.js